module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "br3 bw1 b--silver bg-white items-center flex flex-row main-container mb3 pointer",
    on: {
      "click": _vm.onClick
    }
  }, [_c('new-device', {
    staticClass: "mr3"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column justify-center h-100"
  }, [_c('div', {
    staticClass: "cera-round-pro"
  }, [_vm._v("\n      Add Another Device\n    ")]), _vm._v(" "), (_vm.discount) ? _c('div', {
    staticClass: "black-30 inter f6 mt1"
  }, [_vm._v("\n      Save Additional 5%\n    ")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-514d2b58","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/selectBox/AddPhone.vue
// module id = 757
// module chunks = 0